import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Several of a tab's URL filters in ONE write, back to page 1 — what the
 * card's «+ Фильтр» and its segment switch need. `useTableParams.setFilter`
 * resets the page for one key; two calls in one handler do not compose, and
 * `setFilters` keeps the page.
 */
export function usePatchFilters(): (patch: Record<string, string | null>) => void {
  const [, setSearchParams] = useSearchParams();
  return useCallback(
    (patch) =>
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          for (const [k, v] of Object.entries(patch)) {
            if (v) next.set(k, v);
            else next.delete(k);
          }
          next.delete("page");
          return next;
        },
        { replace: true },
      ),
    [setSearchParams],
  );
}
